import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { DateRangePicker } from 'react-date-range';
import {  startOfDay, endOfDay, isSameDay, startOfWeek, endOfWeek, addDays, differenceInCalendarDays, startOfMonth, endOfMonth, addMonths } from 'date-fns';
import { isMobile } from 'react-device-detect'; 
import { ColumnType } from '../../DataTable/DataTypes';
import { IFloatingFilterParams } from 'ag-grid-community';
import { useDataTableContext } from '../shared/Context';
 


interface DateRangeRenderProps extends IFloatingFilterParams {
    startField?: string;  
    endField?: string;
    name?: string
    column: any;
}

interface CustomDateRange {
    startDate: Date;
    endDate: Date;
    key: string;
}

interface DateRangeRenderState {
    show: boolean;
    emptyDate: CustomDateRange[];
    selectedDate: CustomDateRange[];
    dateRangeStr: string;
}

const CustomDateRangeFloatingFilter: React.FC<DateRangeRenderProps> = (props) => {
  const { floatingFilterValueMap } = useDataTableContext();
  const { parentFilterInstance, api, name } = props;
  const column = props.column as unknown as ColumnType;
  const colId = props.column.getColId();
  const floatingFilterValueMapKey = `${name}${colId}`;
  let defaultDateRangeStr = "";
  if(column?.defaultFilterValue && column?.defaultFilterValue.length > 0){
    const defaultStartDate = column?.defaultFilterValue ? column?.defaultFilterValue[0]?.startDate : new Date().toISOString();
    const defaultEndDate = column?.defaultFilterValue ? column?.defaultFilterValue[0]?.endDate : new Date().toISOString();
    defaultDateRangeStr = `${defaultStartDate.split('T')[0]} - ${defaultEndDate.split('T')[0]}`;
  }
  const initialValue = floatingFilterValueMap.current.get(floatingFilterValueMapKey) ?? (defaultDateRangeStr?.length ? defaultDateRangeStr : "");
  const [searchedValue, setSearchedValue] = useState(initialValue);
  const placeholderName = props.column.getColDef().headerName;

  const getSafeDate = (dateStr) => {
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? new Date() : d;
  };

  const emptyDate = {
    startDate: Array.isArray(column?.defaultFilterValue) && column?.defaultFilterValue[0]?.startDate
        ? getSafeDate(column.defaultFilterValue[0].startDate) : new Date(),
    endDate: Array.isArray(column?.defaultFilterValue) && column?.defaultFilterValue[0]?.endDate
        ? getSafeDate(column.defaultFilterValue[0].endDate) : new Date(),
    key: 'selection'
  };

  const initState = {
    show: false,
    emptyDate: [emptyDate],
    selectedDate: [emptyDate],
    dateRangeStr: searchedValue || '',
  };

  const [state, setState] = useState<DateRangeRenderState>(initState);

  const value = column?.filterParams?.startField;

  useEffect(() => {
    if (value == null) {
      setState(prev => ({ ...prev, dateRangeStr: '' }));
    }
  }, [value]);

    useEffect(() => {
      const floatingFilterValueMapKey = `${name}${colId}`;
      setSearchedValue(floatingFilterValueMap.current.get(floatingFilterValueMapKey) ?? "");
    }, [name]);

  const setCalenderToggle = () => {
    setState(prev => ({ ...prev, show: !prev.show }));
  };

  const handleClose = () => {
    setState(prev => ({ ...prev, show: false }));
  };

  const setSelectedDateHandler = (item) => {
    setState(prev => ({ ...prev, selectedDate: item }));
  };

const dateRangeString = (startDate, endDate) => {
    if (!startDate || !endDate) return '';
    return `${startDate},${endDate}`;
};

const applyDateRange = (dateRangeValueString) => {
    parentFilterInstance((instance) => {
      if (dateRangeValueString === "") {
        instance.setModel(null); 
      } else {
        instance.setModel({
          type: "equals",
          filter: dateRangeValueString,
        });
      }
      api.onFilterChanged();
    });
    setSearchedValue(dateRangeValueString); 
};


const applySearch = () => {
   const selectedDate = [{ startDate: state.selectedDate[0].startDate.toISOString(),endDate: state.selectedDate[0].endDate.toISOString(), key: 'selection'}];

   if (selectedDate && selectedDate[0] && !selectedDate[0]?.startDate && !selectedDate[0]?.endDate) {
      const now = new Date();
      selectedDate[0].startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).toISOString();
      selectedDate[0].endDate = now.toISOString();
    }

    let startDate = new Date(String(state?.selectedDate[0]?.startDate));
    let endDate = new Date(String(state?.selectedDate[0]?.endDate)) ;

    if (isSameDay(startDate, endDate)) {
      startDate = startOfDay(startDate);
      endDate = endOfDay(endDate);
    }

    if (selectedDate[0]?.startDate && selectedDate[0]?.endDate) {
      selectedDate[0].startDate = startDate.toISOString();
      selectedDate[0].endDate = endOfDay(endDate).toISOString();
    }
    
    applyDateRange(dateRangeString(selectedDate[0].startDate, selectedDate[0].endDate));  
 
    const dateRangeStr = `${startDate?.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
    const floatingFilterValueMapKey = `${name}${colId}`;
    floatingFilterValueMap.current.set(floatingFilterValueMapKey, dateRangeStr);
    setState(prev => ({ ...prev, show: false, dateRangeStr }));
  };


const clearSearch = () => {
  
  if(searchedValue !== ""){
        applyDateRange("");
        setSearchedValue("");
  }

  setState(prev => ({
        ...prev,
        show: false,
        selectedDate: [emptyDate],
        dateRangeStr: ''
  }));
  const floatingFilterValueMapKey = `${name}${colId}`;
  floatingFilterValueMap.current.set(floatingFilterValueMapKey, "");
};

  useEffect(() => {
    if (column?.defaultFilterValue && column?.defaultFilterValue.length > 0) {
      const selectedDate = column?.defaultFilterValue;
      const startDate = new Date(String(selectedDate[0].startDate));
      const endDate = new Date(String(selectedDate[0].endDate));
      const dateRangeStr = `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
      setState(prev => ({ ...prev, dateRangeStr }));

      parentFilterInstance((instance) => {
        if (dateRangeStr === "") {
          instance.setModel(null); 
        } else {
          instance.setModel({
            type: "equals",
            filter: dateRangeStr,
          });
        }
        // api.onFilterChanged();
      });
    setSearchedValue(dateRangeStr);
    }
  }, []);

  useEffect(() => {
    const selectedDate = column;
    if (selectedDate && selectedDate[0]?.startDate !== selectedDate[0]?.endDate) {
      const newStartDate = String(selectedDate[0].startDate).replace(/%3A/g, ":");
      const newEndDate = String(selectedDate[0].endDate).replace(/%3A/g, ":");
      const startDate = new Date(newStartDate);
      const endDate = new Date(newEndDate);
      const dateRangeStr = `${startDate?.toLocaleDateString()} - ${endDate.toLocaleDateString()}`;
      setState(prev => ({ ...prev, dateRangeStr }));
    }
  }, []);

  const definedDates = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  };

  const defaultInputRangesData = [
    {
      label: 'days up to today',
      range(value) {
        if (value) {
          return {
            startDate: addDays(definedDates.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
            endDate: definedDates.endOfToday,
            clearField: false,
          };
        }
        return { startDate: new Date(), endDate: new Date(), clearField: true };
      },
      getCurrentValue(range: any) {
        if (range.clearField) return "";
        if (!isSameDay(range.endDate, definedDates.endOfToday)) return '-';
        if (!range.startDate) return '∞';
        return differenceInCalendarDays(definedDates.endOfToday, range.startDate) + 1;
      },
    },
    {
      label: 'days starting today',
      range(value) {
        const today = new Date();
        if (value) {
          return {
            startDate: today,
            endDate: addDays(today, Math.max(Number(value), 1) - 1),
            clearField: false,
          };
        }
        return { startDate: today, endDate: new Date(), clearField: true };
      },
      getCurrentValue(range: any) {
        if (range.clearField) return "";
        if (!isSameDay(range.startDate, definedDates.startOfToday)) return '-';
        if (!range.endDate) return '∞';
        return differenceInCalendarDays(range.endDate, definedDates.startOfToday) + 1;
      },
    },
  ];

  const DateRangePickerAny: any = DateRangePicker;

  return (
  <div style={{ width: "100%" }}>
      <input
        type="text"
        className="ag-input-field-input"
        style={{ paddingLeft: "10px", width: "100%" }}
        readOnly
        onClick={setCalenderToggle}
        onChange={() => {}}
        value={state.dateRangeStr}
        placeholder={`Search ${placeholderName}`}
      />
      <Modal
        show={state.show}
        onHide={handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Please select Date range
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={isMobile ? 'modal-body-mobile' : ''}>
          <DateRangePickerAny
            onChange={item => setSelectedDateHandler([item.selection])}
            moveRangeOnFirstSelection={true}
            editableDateInputs={false}
            months={2}
            direction={isMobile ? 'vertical' : "horizontal"}
            ranges={state.selectedDate}
            inputRanges={defaultInputRangesData}
            maxDate={new Date()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={applySearch}>Apply</Button>
          <Button variant="outline-dark" onClick={clearSearch}>Clear</Button>
          <Button variant="outline-dark" onClick={setCalenderToggle}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomDateRangeFloatingFilter;
